import * as React from 'react';
import cn from 'clsx';

import { IBonus } from '../../types/promoInfo';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { BonusCardDefault, BonusCardExtended } from './components';
import { IWithDeviceTypeProps, withDeviceType } from '../../utils/withDeviceType';
import { shouldHaveExtendedCard } from './utils/shouldHaveExtendedCard';

import * as styles from './styles.css';

interface IBonusesSectionProps extends IWithDeviceTypeProps {
  bonuses: IBonus[];
  onBonusClick: (bonus: IBonus) => void;
}

/**
 * Секция бонусов и скидок.
 */
const BonusesSection: React.FC<React.PropsWithChildren<IBonusesSectionProps>> = ({
  deviceType,
  isDesktop,
  bonuses,
  onBonusClick,
}) => {
  const hasExtendedCard = shouldHaveExtendedCard({ isDesktop, total: bonuses.length });

  return (
    <>
      <ScreenReaderOnly>
        <h2>Бонусы и скидки</h2>
      </ScreenReaderOnly>
      <div
        className={cn(styles['bonuses'], styles[deviceType], {
          [styles['with-extended']]: hasExtendedCard,
        })}
      >
        {bonuses.map((bonus, index) =>
          hasExtendedCard && index === 0 ? (
            <BonusCardExtended key={index} bonus={bonus} onBonusClick={onBonusClick} />
          ) : (
            <BonusCardDefault key={index} bonus={bonus} onBonusClick={onBonusClick} />
          ),
        )}
      </div>
    </>
  );
};

const BonusesSectionWithDeviceType = withDeviceType(BonusesSection);
export { BonusesSectionWithDeviceType as BonusesSection };
